export const ServiceType = {
  GSTIN: "gstin",
  INCOME_TAX: "income-tax",
  TDS: "tds",
};

export const CardTypes = {
  LAST_15_DAYS: "last_15_days",
  LAST_24_HOURS: "last_3_days",
  ACTIVE_CLIENTS: "total_active_clients",
  DISABLE_CLIENTS: "total_inactive_clients",
  TOTAL_NOTICES: "total_notices",
  OPEN_NOTICES: "open_notices",
  OVER_DUE: "over_due",
  OVER_DUE_7_DAYS: "due_within_7_days",
  FAILED_LOGIN: "login_failed",
};
